export const VIEW_TEAM = "/view/team";
export const VIEW_PLAYER_TEAM = "/player/team";
